window.handle = require("handlebars/dist/handlebars.js");

handle.registerHelper('stripHtml', function (label) {

    label = handle.escapeExpression(label);
    if (label.indexOf("-->", 3) != -1) {

        var comment_position = parseInt(label.indexOf("-->", 3));
        return new handle.SafeString(label.substr(comment_position + 3));

    } else {

        return new handle.SafeString(label)

    }

});

// Add this to your document ready function
$(document).ready(function() {
    $("#non_pec_submit").css('display', 'none');
});
    


function getFormattedDate() {
    var currentDate = new Date();

    // Get the year, month, day, hours, minutes, and seconds
    var year = currentDate.getFullYear();
    var month = ('0' + (currentDate.getMonth() + 1)).slice(-2); // Months are zero-based
    var day = ('0' + currentDate.getDate()).slice(-2);
    var hours = ('0' + currentDate.getHours()).slice(-2);
    var minutes = ('0' + currentDate.getMinutes()).slice(-2);
    var seconds = ('0' + currentDate.getSeconds()).slice(-2);

    // Format the date string
    return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
}

var isValid = false;
var _processingText1 = "Checking Colleges in <span style='color:#ff8300;'>" + $("input[name='city']").val() + "</span>.";

class Main {

    constructor() {
    // Add this to your constructor
// TikTok Event tester
// $(document).ready(() => {
//     if (window.location.search.includes('affid=36412') || window.location.search.includes('affid=36308')) {
//         $('body').append(`
//             <div id="tiktok-test-panel" style="position:fixed; bottom:20px; right:20px; z-index:9999; 
//                                               background: white; padding: 15px; border-radius: 8px; 
//                                               box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
//                 <button 
//                     onclick="main.testTikTokEvents()" 
//                     style="padding: 10px 20px; background: #ff8300; color: white; 
//                            border: none; border-radius: 4px; cursor: pointer; 
//                            font-weight: bold; display: block; width: 100%;">
//                     Test TikTok Events
//                 </button>
//                 <div style="font-size: 12px; margin-top: 8px; color: #666;">
//                     1. Open TikTok Pixel Helper<br>
//                     2. Click button to test<br>
//                     3. Check console (F12) for logs
//                 </div>
//             </div>
//         `);
//     }
// });

        this.conversionCount = 0;
        if (!window.jQuery) { ////if jquery isn't loaded, then try to load it again
            let script = document.createElement('script');
            document.head.appendChild(script);
            script.type = 'text/javascript';
            script.src = "https://d3ingq5rreduqs.cloudfront.net/public/js/ajax/libs/jquery/3.1.0/jquery.min.js";
        }

        var _this = this

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="session-token"]').attr('content')
            }
        });

        $(".zip").on("change", function () {
            _this.zipValidator($(this));
        });

        $(".phone").on("change", function() {
            const phoneNumber = $('#phone1').val();
            $("#phoneValidator").addClass("disabled");
            _this.phoneValidator($(this));
            
            // Update all elements with pecphone class
            $('.pecphone').each(function() {
                $(this).html(phoneNumber);
            });
            
            const aiuTcpa = `I acknowledge that, by clicking the checkbox as my electronic signature, I consent to representatives of American InterContinental University, a member of the American InterContinental University System contacting me about educational opportunities via email, text, or phone, including my mobile phone number(s) ${phoneNumber}, using an automatic dialer. Message and data rates may apply. I understand that my consent is not required to purchase any goods or services, and I may withdraw my consent at any time.`;
            
            const ctuTcpa = `I acknowledge that, by clicking the checkbox as my electronic signature, I consent to representatives of Colorado Technical University contacting me about educational opportunities via email, text, or phone, including my mobile phone number(s) ${phoneNumber}, using an automatic dialer. Message and data rates may apply. I understand that my consent is not required to purchase any goods or services, and I may withdraw my consent at any time.`;

            if ($('#label_for_leadid_tcpa_disclosure_P').length) {
                $('#label_for_leadid_tcpa_disclosure_P').html(aiuTcpa);
                $('#directsubmit_tcpa').val(aiuTcpa.replace(/\s+/g, ' ').replace(/\"/g, "").trim());
            }

            if ($('#label_for_leadid_tcpa_disclosure_P_2').length) {
                $('#label_for_leadid_tcpa_disclosure_P_2').html(ctuTcpa);
                $('#directsubmit_tcpa_2').val(ctuTcpa.replace(/\s+/g, ' ').replace(/\"/g, "").trim());
            }
        });
        
        $("#us_military").on("change", function () {
            $(this).val() !== "No U.S. Military Affiliation" ? $("#military_affiliation").fadeIn("fast") : $("#military_affiliation").fadeOut();
        });

        $("#emailAddressField").on("change", (function () {
            _this.emailValidator($(this).val())
        }));

        // filter out special characters
        $('input[name="fname"]').on("keyup", function (event) {
            let validator = /[0-9*|\":<>[\]{}`\\();@&$!#%^_+=?./]/;
            let txt = $(this).val();
            if (validator.test(txt)) {
                $(this).val(txt.replace(/[^a-zA-Z ]/g, ''));
            }
        });

        // filter out special characters
        $('input[name="lname"]').on("change", function () {
            let validator = /[0-9*|\":<>[\]{}`\\();@&$!#%^_+=?./]/;
            let txt = $(this).val();
            if (validator.test(txt)) {
                $(this).val(txt.replace(/[^a-zA-Z ]/g, ''));
            }
        });

        $("#firstNameField, #lastNameField").on("change", function () {
            if ($(this).val().length < 2 || $(this).val().length > 50) {
                $("#name-error").fadeIn(300);
                return false;
            } else {
                $("#name-error").css({
                    display: "none"
                });
            }
        })

        this._current_lead_counter = 0;
        this._current_matched_counter = 0;

        // set the query string
        if (window.location.href.indexOf("?") == -1) {
            this._queryString = "";
        } else {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            this._queryString = urlParams.toString();
            this.appendCakeValues(this._queryString);
        }

        this.directSubmit = $('#directsubmit').val();
        this.retarget = window.location.href.indexOf("retarget");

        // turns ellipsis 90 degrees if directsubmit is active
        if (this.directSubmit) {
            this._loadDomTemplate = '<div class="ldTemplate-wrapper" style="padding: 0;"><div class="mydegree-ellipsis" style="transform: rotate(90deg)"><div></div><div></div><div></div><div></div></div><div><h2 class="processing-text"></h2></div><div class="mydegree-ellipsis" style="transform: rotate(90deg)"><div></div><div></div><div></div><div></div></div></div>';
        } else {
            this._loadDomTemplate = '<div class="ldTemplate-wrapper"><div class="mydegree-ellipsis"><div></div><div></div><div></div><div></div></div><div><h2 class="processing-text"></h2></div><div class="mydegree-ellipsis"><div></div><div></div><div></div><div></div></div></div>';
        }

        if (this.retarget !== -1) {
            $("html, body").animate({
                scrollTop: 0
            }, "fast");
            var parentClass = this;
            parentClass._validatingText1 = "Validating your request";
            if (this.directSubmit == 'pec') {
                _processingText1 = "Congratulations, your information has been submitted to the following institutions: <br>" + "<img src=\"https://d3ingq5rreduqs.cloudfront.net/public/b34eeeede18178d9117f3a56450ac209.jpeg\"  width=\"50%\" style=\"padding-top: 10px;\" alt=\"AIU\"> <img src=\"https://d3ingq5rreduqs.cloudfront.net/public/74c2c502a4280e91cd84e21a0794142c.png\" alt=\"CTU\"  width=\"30%\" style=\"padding-bottom: 10px;\">" + "<br>Seaching for more school matches..."
            } else if (this.directSubmit == 'purdueandpec') {
                _processingText1 = "Congratulations, your information has been submitted to the following institutions: <br>" + "<img src=\"https://d3ingq5rreduqs.cloudfront.net/public/b34eeeede18178d9117f3a56450ac209.jpeg\"  width=\"30%\" style=\"padding-top: 10px;\" alt=\"AIU\"> <img src=\"https://d3ingq5rreduqs.cloudfront.net/public/74c2c502a4280e91cd84e21a0794142c.png\" alt=\"CTU\"  width=\"30%\" style=\"padding-bottom: 10px;\">" + "<img src=\"https://d3ingq5rreduqs.cloudfront.net/public/4c156a085f94c802cdf94e148fbc67b4.png\"  width=\"30%\" style=\"padding-top: 10px;\" alt=\"Purdue\">" + "<br>Seaching for more school matches..."
            } else if (this.directSubmit == 'purdue' || this.directSubmit == 'purduex') {
                _processingText1 = "Congratulations, your information has been submitted to the following institution: <br>" + "<img src=\"https://d3ingq5rreduqs.cloudfront.net/public/4c156a085f94c802cdf94e148fbc67b4.png\"  width=\"50%\" style=\"padding-top: 10px;\" alt=\"Purdue\">" + "<br>Searching for more school matches..."
            } else if (this.directSubmit == 'revadsu') {
                _processingText1 = "Congratulations, your information has been submitted to the following institution: <br>" + "<img src=\"https://d3ingq5rreduqs.cloudfront.net/public/d5b97fe2fb9e4e5ca8205ae9f3438e94.png\"  width=\"50%\" style=\"padding-top: 10px;\" alt=\"Revadsu\">" + "<br>Searching for more school matches..."
            } else if (this.directSubmit == 'revadsuandleadvision') {
                _processingText1 = "Congratulations, your information has been submitted to the following institution: <br>" + "<img src=\"https://d3ingq5rreduqs.cloudfront.net/public/d5b97fe2fb9e4e5ca8205ae9f3438e94.png\"  width=\"50%\" style=\"padding-top: 10px;\" alt=\"Revadsu\">" + "<br>Searching for more school matches..."
            } else {
                _processingText1 = "Checking Colleges</span>";
            }
            parentClass._processingText2 = "Checking <span style='color:#ff8300;'>" + $("select[name='subject']").find("option:selected").text() + "</span> Colleges in your area.";
            parentClass._processingText3 = "Compiling your results";
            parentClass.waitForElm('#leadid_token').then(function () {
                parentClass.waitForElm('#xxTrustedFormToken_0').then(function () {
                    $.when(parentClass.searchSchoolRetarget(parentClass))
                        .then(function (data) {
                            parentClass.processLastField();
                            parentClass._schoolResults = data;
                            parentClass.displayCollegeResults(parentClass);
                        }).fail(function (data) {
                            let url = new URL(location.href);
                            url.searchParams.delete('retarget');
                            location.assign(url);
                        });
                });
            })
        }

        $(window).keydown(function (event) {
            if (event.keyCode == 13) {
                event.preventDefault();
                return false;
            }
        });
        // when submitting leads on the dynamic html

        $("#school_match").on("click", ".continue-submit-lead-button", function (e) {
            //e.schoolSearch();
            e.preventDefault();
            $(this).prop('disabled', true);
            _this.submitLead($(this));
        });

        $("#school_match").on("click", ".select_match_tcpa, #accept_check", function (e) {
            let $continue = $("#continueButton");
            const $select_match_tcpa = $("input[name='is_interested'].select_match_tcpa");
            const $accept_check = $("#accept_check");
            let enableContinue = false;

            if ($select_match_tcpa.length > 0 && $accept_check.length > 0) {
                // Both checkboxes exist and both are require to be checked
                if ($select_match_tcpa.is(':checked') && $accept_check.is(':checked')) {
                    enableContinue = true;
                    $(".needSelectConsentButtonDiv").remove();
                    $("#select-tcpa-error").css({
                        display: "none"
                    });
                    $('#tcpa_area_box').css("border", "1px solid rgb(71,109,116)");
                } else {
                    $("#school_match").find(".continue-submit-lead-button").after('<div class="needSelectConsentButtonDiv" style="position:absolute; top:0; left:0; width: 100%; height:100%;"></div>');
                }
            } else if ($select_match_tcpa.length > 0) {
                // Only if select_match_tcpa exists and is required to be checked
                if ($select_match_tcpa.is(':checked')) {
                    enableContinue = true;
                    $(".needSelectConsentButtonDiv").remove();
                    $("#select-tcpa-error").css({
                        display: "none"
                    });
                    $('#tcpa_area_box').css("border", "1px solid rgb(71,109,116)");
                } else {
                    $("#school_match").find(".continue-submit-lead-button").after('<div class="needSelectConsentButtonDiv" style="position:absolute; top:0; left:0; width: 100%; height:100%;"></div>');
                }
            } else if ($accept_check.length > 0) {
                // Only if accept_check exists and is required to be checked
                if ($accept_check.is(':checked')) {
                    enableContinue = true;
                    $(".needSelectConsentButtonDiv").remove();
                } else {
                    $("#school_match").find(".continue-submit-lead-button").after('<div class="needSelectConsentButtonDiv" style="position:absolute; top:0; left:0; width: 100%; height:100%;"></div>');
                }
            } else {
                // If non of the checkbox exists (May happen)
                enableContinue = true;
                $(".needSelectConsentButtonDiv").remove();
                $("#select-tcpa-error").css({
                    display: "none"
                });
                $('#tcpa_area_box').css("border", "1px solid rgb(71,109,116)");
            }

            $continue.prop('disabled', !enableContinue)
        })

        $("#school_match").on("click", "#axd-pixel", function (e) {

            let md_submit_lead_url = "assets/ajax/lead-submit.php";

            if (ace_report.accepted) {
                $(".ace-form").append('<input type="hidden" value="success" name="response"/>');
                let data = $("form").serialize();
                $.when(_this.makePostRequest(md_submit_lead_url, data)).then(function (response2) {
                    if (typeof gtag === "function") {
                        gtag("event", "conversion_axd", {
                            'event_category': "engagement",
                            'event_label': response2[3]
                        });
                    }
                    _this.skipLead();
                });
            } else {
                $(".ace-form").append('<input type="hidden" value="failure" name="response"/>');
                let data = $("form").serialize();
                $.when(_this.makePostRequest(md_submit_lead_url, data)).then(function (response2) {
                    _this.skipLead();
                });
            }
        });

        $("#school_match").on("click", ".skip-this", function () {
            _this.skipLead();
        });

        $(".leadid_checkbox").on("click", function () {
            let $continue = $("#pec-continue");
            let $submitContinue = $("#submit-continue");
            let tcpa_1_box = $('#direct_submit_tcpa_box');
            let tcpa_2_box = $('#direct_submit_tcpa_box_2');
            let general_tcpa_box = $('#general_submit_tcpa_box');  // This is the correct variable definition
            let tcpa_1_check = $('#leadid_tcpa_disclosure_P');
            let tcpa_2_check = $('#leadid_tcpa_disclosure_P_2');
            let general_tcpa_disclosure_P = $('#general_tcpa_disclosure_P');

            // Changed general_submit_tcpa_box to general_tcpa_box here
            let valid_general = general_tcpa_box.is(":visible") ? general_tcpa_disclosure_P.prop("checked") : true;

            if((tcpa_1_box.is(":visible") && tcpa_1_check[0].checked) && isValid){
                if(tcpa_2_box.is(":visible")){
                    if(tcpa_2_check[0].checked){
                        $continue.prop('disabled', false); // If checked enable item
                        $(".needConsentButtonDiv").remove();
                        $('#direct_submit_tcpa_box').css("border", "1px solid rgb(71,109,116)");
                        $('#direct_submit_tcpa_box_2').css("border", "1px solid rgb(71,109,116)");
                        //scroll to $continue
                        $('html, body').animate({ scrollTop: $("#section_for_P_TCPA").offset().top }, 500);
                        $("#tcpa-error").css({
                            display: "none"
                        });
                    } else if (general_tcpa_disclosure_P.is(':checked')) {
                        $submitContinue.prop('disabled', false);
                        $(".needConsentButtonDiv").remove();
                        // $("#tcpa-error").hide();
                        general_tcpa_box.css("border", "1px solid rgb(71,109,116)");
                        $("#tcpa-error").css({
                            display: "none"
                        });
                        // Changed general_submit_tcpa_box to general_tcpa_box here too
                    } else {
                        $continue.prop('disabled', true); // If not checked disable item
                        $continue.after('<div class="needConsentButtonDiv" style="position:absolute; top:0; left:0; width: 100%; height:100%;"></div>');
                    }
                } else {
                    $continue.prop('disabled', false); // If checked enable item
                    $(".needConsentButtonDiv").remove();
                    $('#direct_submit_tcpa_box').css("border", "1px solid rgb(71,109,116)");
                    //scroll to $continue
                    $('html, body').animate({ scrollTop: $("#section_for_P_TCPA").offset().top }, 500);
                    $("#tcpa-error").css({
                        display: "none"
                    });
                }
            } else {
                $continue.prop('disabled', true); // If not checked disable item
                $continue.after('<div class="needConsentButtonDiv" style="position:absolute; top:0; left:0; width: 100%; height:100%;"></div>');
            }
        });

        $('body').on('click', '.needConsentButtonDiv', function () {
            let tcpa_1_box = $('#direct_submit_tcpa_box');
            let tcpa_2_box = $('#direct_submit_tcpa_box_2');
            let general_tcpa_box = $('#general_submit_tcpa_box');
            let tcpa_1_check = $('#leadid_tcpa_disclosure_P');
            let tcpa_2_check = $('#leadid_tcpa_disclosure_P_2');
            let general_tcpa_disclosure_P = $('#general_tcpa_disclosure_P');
            if (tcpa_1_box.is(":visible") && tcpa_1_check.is(':visible') && $('#pec-continue').is(':disabled') && !tcpa_1_check[0].checked) {
                $("#tcpa-error").fadeIn(100);
                tcpa_1_box.css("border", "3px solid red");
                $('html, body').animate({scrollTop: $("#tcpa-error").offset().top }, 500 );
            }
            if (tcpa_2_box.is(":visible") && tcpa_2_check.is(':visible') && $('#pec-continue').is(':disabled') && !tcpa_2_check[0].checked) {
                $("#tcpa-error").fadeIn(100);
                tcpa_2_box.css("border", "3px solid red");
                $('html, body').animate({scrollTop: $("#tcpa-error").offset().top }, 500 );
            }
            if (general_tcpa_box.is(":visible") && general_tcpa_disclosure_P.is(':visible') && $('#submit-continue').is(':disabled') && !general_tcpa_disclosure_P[0].checked) {
                $("#tcpa-error").fadeIn(100);
                general_tcpa_box.css("border", "3px solid red");
                $('html, body').animate({scrollTop: $("#tcpa-error").offset().top }, 500 );
            }
        });

        $('body').on('click', '.needSelectConsentButtonDiv', function () {
            if ($('#continueButton').is(':disabled')) {
                $("#select-tcpa-error").fadeIn(100);
                $('#tcpa_area_box').css("border", "3px solid red");
                $('html, body').animate({scrollTop: $("#select-tcpa-error").offset().top}, 500 );
            }
        });

        
   

        $('body').on('click', '.concentration_checkbox', function (e) {
            if (!$(this).hasClass('undecided-option')) {
                if ($(this).closest('.concentrations').find('.undecided-option').is(":checked")) {
                    $(this).closest('.concentrations').find('.undecided-option').prop("checked", false)
                    $(this).closest('.concentrations').find('.undecided-option').removeAttr('checked');
                }
                let count_checked = 0;
                $(this).closest('.concentrations').find('.concentration_checkbox').each(function () {
                    if ($(this).is(":checked")) {
                        count_checked++;
                    }
                });
                if (count_checked == 0) {
                    $(this).closest('.concentrations').find('.undecided-option').prop("checked", true);
                }
            } else {
                e.preventDefault();
                return false;
            }
        });

    }

    doPecLogic() {
        var parentClass = this;
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.get('ckmsc') && urlParams.get('ckmc') && !urlParams.get('reqid')) {
            $('#reqid').val(parentClass.getCookie('ckmsid'));
        } else if(urlParams.get('reqid')){
            $('#reqid').val(urlParams.get('reqid'));
        }
        if ($('#firstNameField').val().length < 2 || $('#firstNameField').val().length > 50) {
            $("#direct_submit_tcpa_box").css('display', 'none');
            $("#direct_submit_tcpa_box_2").css('display', 'none');
            return false;
        }

        if ($('#lastNameField').val().length < 2 || $('#lastNameField').val().length > 50) {
            $("#direct_submit_tcpa_box").css('display', 'none');
            $("#direct_submit_tcpa_box_2").css('display', 'none');
            return false;
        }

        if ($("#emailAddressField").val().length < 8) {
            $("#direct_submit_tcpa_box").css('display', 'none');
            $("#direct_submit_tcpa_box_2").css('display', 'none');
            return false;
        }

        const emailRegex = /^[a-zA-Z0-9._-]{3,}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        let email = $("#emailAddressField").val();

        if (emailRegex.test(email)) {

            setTimeout(() => {
                if (!isValid) {
                    $("#pec-continue").prop('disabled', true);
                    $("#direct_submit_tcpa_box").css('display', 'none');
                    $("#direct_submit_tcpa_box_2").css('display', 'none');
                    return false;
                };
            }, 500);
        } else {
            $("#direct_submit_tcpa_box").css('display', 'none');
            $("#direct_submit_tcpa_box_2").css('display', 'none');
            return false;
        }
        const affid = urlParams.get('affid');
        this._validatingText1 = "Validating your request";

        $.ajax({
            type: 'POST',
            dataType: 'json',
            data: $("form").serialize(),
            url: "assets/ajax/pecPing.php",
            cache: false,
            beforeSend: function () {
                $(".needConsentButtonDiv").css('display', 'none');
                $("#non_pec_submit").css('display', 'none');
                $(".loader").css("display", "block");
                $('#sectionForTCPA2').html('');
                $('#sectionForTCPA2').css('display', 'none');
                $('#section_for_P_TCPA').css('display', 'none');
                $('#section_for_P_TCPA_2').css('display', 'none');
                $("#pec_submit_button_div").css('display', 'none');

            },
            success: function (resp) {
                $(".loader").css("display", "none");
                if (typeof resp == "object") {
                    const phoneNumber = $('#phone1').val();
                    // resp.aiu = true;
                    // resp.ctu = true;

                    if (resp.aiu == true || resp.ctu == true) {
                        $('#directsubmit').val('pec');
                        $('#isDirectSubmit').val(true);
                        $('.needConsentButtonDiv').css('display', 'block');
                    }
                    if (resp.aiu == true && resp.ctu == true) {
                        const aiuTcpa = `I acknowledge that, by clicking the checkbox as my electronic signature, I consent to representatives of American InterContinental University, a member of the American InterContinental University System contacting me about educational opportunities via email, text, or phone, including my mobile phone number(s) ${phoneNumber}, using an automatic dialer. Message and data rates may apply. I understand that my consent is not required to purchase any goods or services, and I may withdraw my consent at any time.`;
            
                        const ctuTcpa = `I acknowledge that, by clicking the checkbox as my electronic signature, I consent to representatives of Colorado Technical University contacting me about educational opportunities via email, text, or phone, including my mobile phone number(s) ${phoneNumber}, using an automatic dialer. Message and data rates may apply. I understand that my consent is not required to purchase any goods or services, and I may withdraw my consent at any time.`;
                        
                        // Set frontend labels
                        $('#label_for_leadid_tcpa_disclosure_P').html(aiuTcpa);
                        $('#label_for_leadid_tcpa_disclosure_P_2').html(ctuTcpa);
                        
                        // Set hidden inputs for backend
                        $('#directsubmit_tcpa').val(aiuTcpa.replace(/\s+/g, ' ').replace(/\"/g, "").trim());
                        $('#directsubmit_tcpa_2').val(ctuTcpa.replace(/\s+/g, ' ').replace(/\"/g, "").trim());
                        $('#section_for_P_TCPA').css('display', 'block');
                        $('#section_for_P_TCPA_2').css('display', 'block');
                        $('#pec_submit_button_div').css({ "display": "flex", "justify-content": "center" });
                        $('#non_pec_submit').hide();
                        _processingText1 = "Congratulations, your information has been submitted to the following institutions: <br>" + "<img src=\"https://d3ingq5rreduqs.cloudfront.net/public/b34eeeede18178d9117f3a56450ac209.jpeg\"  width=\"50%\" style=\"padding-top: 10px;\" alt=\"AIU\"> <img src=\"https://d3ingq5rreduqs.cloudfront.net/public/74c2c502a4280e91cd84e21a0794142c.png\" alt=\"CTU\"  width=\"30%\" style=\"padding-bottom: 10px;\">" + "<br>Seaching for more school matches..."
                        $("#aiu_score").val(resp.aiu_score || "G");
                        $("#aiu_payout").val(resp.aiu_payout || 0);
                        $("#aiu_cec_unique_id").val(resp.aiu_cec_unique_id || 0);
                        $("#ctu_score").val(resp.ctu_score || "G");
                        $("#ctu_payout").val(resp.ctu_payout || 0);
                        $("#ctu_cec_unique_id").val(resp.ctu_cec_unique_id || 0);
                        $("#pec-continue").prop('disabled', true);
                        $("#direct_submit_tcpa_box").css('display', 'inline-flex');
                        $("#direct_submit_tcpa_box_2").css('display', 'inline-flex');
                        $('#extra_text_for_g_both').show();
                        $('#extra_text_for_g_single').hide();
                    } else if (resp.aiu == true) {
                        const aiuTcpa = `I acknowledge that, by clicking the checkbox as my electronic signature, I consent to representatives of American InterContinental University, a member of the American InterContinental University System contacting me about educational opportunities via email, text, or phone, including my mobile phone number(s) ${phoneNumber}, using an automatic dialer. Message and data rates may apply. I understand that my consent is not required to purchase any goods or services, and I may withdraw my consent at any time.`;

                        $('#directsubmit').val('pec');
                        $('#isDirectSubmit').val(true);

                        $('#label_for_leadid_tcpa_disclosure_P').html(aiuTcpa);
                        
                        $('#directsubmit_tcpa').val(aiuTcpa.replace(/\s+/g, ' ').replace(/\"/g, "").trim());
                        $('#directsubmit_tcpa_2').val("");

                        $('#section_for_P_TCPA').css('display', 'block');
                        $("#pec-continue").css('display', 'block');
                        $('#pec_submit_button_div').css({ "display": "flex", "justify-content": "center" });
                        $('#non_pec_submit').hide();
                        _processingText1 = "Congratulations, your information has been submitted to the following institutions: <br>" + "<img src=\"https://d3ingq5rreduqs.cloudfront.net/public/b34eeeede18178d9117f3a56450ac209.jpeg\"  width=\"50%\" style=\"padding-top: 10px;\" alt=\"AIU\">" + "<br>Seaching for more school matches..."
                        $("#aiu_score").val(resp.aiu_score || "G");
                        $("#aiu_payout").val(resp.aiu_payout || 0);
                        $("#aiu_cec_unique_id").val(resp.aiu_cec_unique_id || 0);
                        $("#pec-continue").prop('disabled', true);
                        $("#direct_submit_tcpa_box").css('display', 'inline-flex');
                        $('#extra_text_for_g_single').show();
                        $('#extra_text_for_g_both').hide();
                    }  else if (resp.ctu == true) {
                        const ctuTcpa = `I acknowledge that, by clicking the checkbox as my electronic signature, I consent to representatives of Colorado Technical University contacting me about educational opportunities via email, text, or phone, including my mobile phone number(s) ${phoneNumber}, using an automatic dialer. Message and data rates may apply. I understand that my consent is not required to purchase any goods or services, and I may withdraw my consent at any time.`;

                        $('#directsubmit').val('pec');
                        $('#isDirectSubmit').val(true);

                        $('#label_for_leadid_tcpa_disclosure_P_2').html(ctuTcpa);
                        
                        $('#directsubmit_tcpa').val(ctuTcpa.replace(/\s+/g, ' ').replace(/\"/g, "").trim());
                        $('#directsubmit_tcpa_2').val("");

                        $('#section_for_P_TCPA').css('display', 'block');
                        $("#pec-continue").css('display', 'block');
                        $('#pec_submit_button_div').css({ "display": "flex", "justify-content": "center" });
                        $('#non_pec_submit').hide();
                        _processingText1 = "Congratulations, your information has been submitted to the following institutions: <br>" + "<img src=\"https://d3ingq5rreduqs.cloudfront.net/public/74c2c502a4280e91cd84e21a0794142c.png\" alt=\"CTU\"  width=\"30%\" style=\"padding-bottom: 10px;\">" + "<br>Seaching for more school matches..."
                        $("#ctu_score").val(resp.ctu_score || "G");
                        $("#ctu_payout").val(resp.ctu_payout || 0);
                        $("#ctu_cec_unique_id").val(resp.ctu_cec_unique_id || 0);
                        $("#pec-continue").prop('disabled', true);
                        $("#direct_submit_tcpa_box").css('display', 'inline-flex');
                        $('#extra_text_for_g_single').show();
                        $('#extra_text_for_g_both').hide();
                    } else {
                        const phoneNumber = $('#phone1').val().trim();
                        const tcpaHtml = `
                            I acknowledge that, by clicking the checkbox as my electronic signature, I consent to representatives of 
                            <a style="color:#007bff;">MyDegree</a> contacting me about educational opportunities via email, text, or phone, 
                            including my mobile phone number(s) ${phoneNumber} using an automatic dialer. Message and data rates may apply. 
                            I understand that my consent is not required to purchase any goods or services, and I may withdraw my consent at any time.
                        `;

                        // Clean plain text version (no <a>) for hidden input value
                        const tcpaPlain = `
                            I acknowledge that, by clicking the checkbox as my electronic signature, I consent to representatives of 
                            MyDegree contacting me about educational opportunities via email, text, or phone, 
                            including my mobile phone number(s) ${phoneNumber} using an automatic dialer. Message and data rates may apply. 
                            I understand that my consent is not required to purchase any goods or services, and I may withdraw my consent at any time.
                        `.replace(/\s+/g, ' ').trim();

                        $('#directsubmit_tcpa').val(tcpaPlain.replace(/\s+/g, ' ').replace(/\"/g, "").trim());
                        $('#directsubmit_tcpa_2').val("");

                        _processingText1 = "Checking Colleges in <span style='color:#ff8300;'>" + $("input[name='city']").val() + "</span>.";

                        $("#aiu_score, #aiu_payout, #ctu_score, #ctu_payout").val("");
                        $('#label_for_general_tcpa_disclosure_P').html(tcpaHtml);
                        $('#submit_tcpa').val(tcpaPlain);

                        $('#sectionForTCPA2').css('display', 'block');
                        $('#non_pec_submit').css({ "display": "flex", "justify-content": "center" });
                        $("#submit-continue").prop('disabled', true);
                        $('#pec_submit_button_div').hide();

                        // Remove any existing TCPA box
                        $('#general_tcpa_disclosure_P').remove();
                        $('#general_submit_tcpa_box').remove();

                        // Append the updated checkbox section
                        $('#sectionForTCPA2').html(`
                          <div class="opacity-5">
                            <div id="general_submit_tcpa_box" style="margin:7px 0; display: inline-flex; border: 1px solid rgb(71,109,116); border-radius: 0.15rem; background-color: #D4E6F1; position: relative; padding: 6px;">
                              <div style="position: absolute; left: -25px; top:-20px;">
                                <span class="icon icon5" aria-label="Icon 5"></span>
                              </div>
                              <div style="margin-left: 6px;">
                                <div class="small">
                                  <input type="checkbox" class="leadid_checkbox" id="general_tcpa_disclosure_P" name="mydegree_callcenter_tcpa" value="1">
                                  <label for="general_tcpa_disclosure_P" style="margin:10px 10px 10px 20px; color:black;" class="tcpa">${tcpaHtml}</label>
                                  <input id="general_submit_tcpa" type="hidden" name="general_submit_tcpa" value="${tcpaPlain}" />
                                  <input id="mydegree_callcenter_tcpa" type="hidden" name="mydegree_callcenter_tcpa" value="0" />
                                </div>
                              </div>
                            </div>
                          </div>
                        `);

                        // Disable the submit button initially
                        $('#non_pec_submit button[type="submit"]').prop('disabled', true);

                        // Attach checkbox handler after DOM is updated
                        setTimeout(function () {
                          $('#general_tcpa_disclosure_P').off('change').on('change', function () {
                            if ($(this).is(':checked')) {
                              $('#non_pec_submit button[type="submit"]').prop('disabled', false);
                              $('#mydegree_callcenter_tcpa').val(1);
                              $('#general_submit_tcpa_box').css("border", "1px solid rgb(71,109,116)");
                              $("#tcpa-error").css({ display: "none" });
                              // ✅ Remove the blocker
                                $(".needConsentButtonDiv").hide();
                            } else {
                              $('#non_pec_submit button[type="submit"]').prop('disabled', true);
                              $('#mydegree_callcenter_tcpa').val(0);
                              // ✅ Re-add the blocker
                                $(".needConsentButtonDiv").show();
                            }
                          }).trigger('change'); // Ensure initial state is correct
                        }, 100);
                        
                        // Hide PEC specific elements
                        $('#pec_submit_button_div').css('display', 'none');
                        // $(".needConsentButtonDiv").css('display', 'block');
                    }
                    
                    $('.pecphone').html($('#phone1').val());
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                const phoneNumber = $('#phone1').val().trim();
                const tcpaHtml = `
                    I acknowledge that, by clicking the checkbox as my electronic signature, I consent to representatives of 
                    <a style="color:#007bff;">MyDegree</a> contacting me about educational opportunities via email, text, or phone, 
                    including my mobile phone number(s) ${phoneNumber} using an automatic dialer. Message and data rates may apply. 
                    I understand that my consent is not required to purchase any goods or services, and I may withdraw my consent at any time.
                `;

                // Clean plain text version (no <a>) for hidden input value
                const tcpaPlain = `
                    I acknowledge that, by clicking the checkbox as my electronic signature, I consent to representatives of 
                    MyDegree contacting me about educational opportunities via email, text, or phone, 
                    including my mobile phone number(s) ${phoneNumber} using an automatic dialer. Message and data rates may apply. 
                    I understand that my consent is not required to purchase any goods or services, and I may withdraw my consent at any time.
                `.replace(/\s+/g, ' ').trim();

                $('#directsubmit_tcpa').val(tcpaPlain.replace(/\s+/g, ' ').replace(/\"/g, "").trim());
                        $('#directsubmit_tcpa_2').val("");

                _processingText1 = "Checking Colleges in <span style='color:#ff8300;'>" + $("input[name='city']").val() + "</span>.";

                $("#aiu_score, #aiu_payout, #ctu_score, #ctu_payout").val("");
                $('#label_for_general_tcpa_disclosure_P').html(tcpaHtml);
                $('#submit_tcpa').val(tcpaPlain);

                $('#sectionForTCPA2').css('display', 'block');
                $('#non_pec_submit').css({ "display": "flex", "justify-content": "center" });
                $("#submit-continue").prop('disabled', true);
                $('#pec_submit_button_div').hide();

                // Remove any existing TCPA box
                $('#general_tcpa_disclosure_P').remove();
                $('#general_submit_tcpa_box').remove();

                // Append the updated checkbox section
                $('#sectionForTCPA2').html(`
                  <div class="opacity-5">
                    <div id="general_submit_tcpa_box" style="margin:7px 0; display: inline-flex; border: 1px solid rgb(71,109,116); border-radius: 0.15rem; background-color: #D4E6F1; position: relative; padding: 6px;">
                      <div style="position: absolute; left: -25px; top:-20px;">
                        <span class="icon icon5" aria-label="Icon 5"></span>
                      </div>
                      <div style="margin-left: 6px;">
                        <div class="small">
                          <input type="checkbox" class="leadid_checkbox" id="general_tcpa_disclosure_P" name="mydegree_callcenter_tcpa" value="1">
                          <label for="general_tcpa_disclosure_P" style="margin:10px 10px 10px 20px;" class="tcpa">${tcpaHtml}</label>
                          <input id="general_submit_tcpa" type="hidden" name="general_submit_tcpa" value="${tcpaPlain}" />
                          <input id="mydegree_callcenter_tcpa" type="hidden" name="mydegree_callcenter_tcpa" value="0" />
                        </div>
                      </div>
                    </div>
                  </div>
                `);

                // Disable the submit button initially
                $('#non_pec_submit button[type="submit"]').prop('disabled', true);

                // Attach checkbox handler after DOM is updated
                setTimeout(function () {
                  $('#general_tcpa_disclosure_P').off('change').on('change', function () {
                    if ($(this).is(':checked')) {
                      $('#non_pec_submit button[type="submit"]').prop('disabled', false);
                      $('#mydegree_callcenter_tcpa').val(1);
                      $('#general_submit_tcpa_box').css("border", "1px solid rgb(71,109,116)");
                      $("#tcpa-error").css({ display: "none" });
                      // ✅ Remove the blocker
                        $(".needConsentButtonDiv").hide();
                    } else {
                      $('#non_pec_submit button[type="submit"]').prop('disabled', true);
                      $('#mydegree_callcenter_tcpa').val(0);
                      // ✅ Re-add the blocker
                        $(".needConsentButtonDiv").show();
                    }
                  }).trigger('change'); // Ensure initial state is correct
                }, 100);
                
                // Hide PEC specific elements
                $('#pec_submit_button_div').css('display', 'none');
                // $(".needConsentButtonDiv").css('display', 'block');
            }
        });

    }

    makePostRequest(t, data = null) {
        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
        return null === e ? $.post(t + sales_id) : $.post(t, e)
    }

    waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    ajaxGet(url) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                type: "GET",
                url: url,
            }).done(function (data, status) {
                resolve({
                    data,
                    status
                });
            }).fail(function (data, status) {
                reject({
                    data,
                    status
                });
            });
        });
    };

    zipValidator(t) {
        var zipCode = t.val();
        zipCode.length >= 3 && zipCode.length <= 5 ? this.ajaxGet("assets/ajax/zipVerifier.php?zip=" + zipCode).then((function (t) {

            if (t.data.message) {
                var r = t.data.message;
                $(".getCity, .getState").empty();
                var s = "<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n<i class='fa fa-exclamation-triangle'></i>\n".concat(r, "\n</span>");
                $(".zipError").html(s), $(".zip").addClass('invalid');
                //gtag('event','Validation',{'event_category':'Zip Error','event_label':r});
            } else if (t.data) {
                var e = t.data;
                $(".getCity, .getState").empty(), $(".getCity").html(e.City + ","), $(".getState").html(e.State_abbreviation), $("input[name='city']").val(e.City), $("input[name='state']").val(e.State_abbreviation), $(".zip").removeClass('invalid'), $(".zipError").html("");
            }

        })) : ($(".getCity, .getState").empty(), $(".zipError").html("<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n                                <i class='fa fa-exclamation-triangle'></i>\n                                Please check your USA zip code again.\n                            </span>"), $(".zip").addClass('invalid'));
        //gtag('event','Validation',{'event_category':'Zip Error','event_label':'Please check your USA zip code again'});

    }

    phoneValidator(t) {
        let phoneNumber = t.val();
        if (phoneNumber.length >= 10 && phoneNumber.length <= 14) {
            phoneNumber = phoneNumber.replace(/\D/g, '');
            if (phoneNumber.charAt(0) == 1) {
                phoneNumber = phoneNumber.substring(1);
                t.val(phoneNumber);  // Update the original input
                $('#phoneFormat1').val(phoneNumber);
            }
            
            let validatorUrl = "assets/ajax/newPhoneValidator.php";
            
            this.ajaxGet(validatorUrl + "?phone=" + phoneNumber)
                .then(function (t) {
                    if ("error" === t.data.status) {
                        let r = "<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n                                <i class='fa fa-exclamation-triangle'></i>\n                                ".concat(t.data.error_message, "\n                            </span>");
                        $(".phoneError").empty().html(r);
                        // Keep the continue button disabled
                        $("#phoneValidator").addClass("disabled");
                        
                    } else {
                        $(".phoneError").html("");
                        $(".phone").removeClass('invalid');
                        let e = t.data;
                        $('#phoneFormat1').val(phoneNumber.replace(/\D/g, ''));
                        // Enable the continue button
                        $("#phoneValidator").removeClass("disabled");
                    }
                });
        } else {
            $(".phoneError").html("<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n<i class='fa fa-exclamation-triangle'></i>\n Please enter a valid US Phone Number.\n</span>");
            $(".phone").addClass('invalid');
            // Keep the continue button disabled
            $("#phoneValidator").addClass("disabled");
        }
    }

    fetchWithTimeout(url, options, timeout = 3000) {
        return Promise.race([
            fetch(url, options),
            new Promise((_, reject) =>
                setTimeout(() => reject(new Error('timeout')), timeout)
            )
        ]);
    }

    emailValidator(email) {

        if (email.length >= 6 && email.length <= 256) {
            let _this = this;
            $.ajax({
                type: "GET",
                url: "assets/ajax/emailValidator.php?email=" + email,
                dataType: "json",
                accept: "json",
                success: function (t) {

                    if ("success" === t.status) {

                        if (t.error_message === "Email API timeout.") {
                            // Make Ajax call
                            $.ajax({
                                url: "https://trkdb.datagenetx.com/public/api/log-timeout", // Replace with endpoint URL configured on Laravel
                                method: "POST",
                                data: { message: "Email API timed out", api_url: "http://api.emailoversight.com/api/EmailValidation?apitoken=00027b30-3981-4557-acd6-26c1d285524c&listid=" }
                            })
                        }

                        $(".emailError").html(""), $("#emailAddressField").removeClass('invalid');
                        if (typeof gtag === "function") {
                            gtag('event', 'Validation', {
                                'event_category': 'Email Validated',
                                'event_label': 'Email'
                            });
                        }
                        isValid = true;
                        // Inline field checking
                        var firstName = $("#firstNameField").val().trim();
                        var lastName = $("#lastNameField").val().trim();
                        var email = $("#emailAddressField").val().trim();
                        
                        // Check if all fields have values and call doPecLogic if they do
                        if (firstName !== "" && lastName !== "" && email !== "") {
                            // doPecLogic(); // Call directly
                            _this.doPecLogic();
                        }
                    } else if ("failure" === t.status) {
                        var r = "<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n<i class='fa fa-exclamation-triangle'></i>\n".concat(t.error_message, "\n</span>");
                        $(".emailError").empty().html(r)
                        isValid = false;
                    }
                }
            })


            //     if ("success" === t.data.status) {

            //         // if error message == "Email API timeout", do a Ajax call

            //         if (t.data.error_message === "Email API timeout.") {
            //             // Make Ajax call
            //             $.ajax({

            //                 url: "https://trkdb.datagenetx.com/public/api/log-timeout", // Replace with endpoint URL configured on Laravel
            //                 method: "POST",
            //                 data: { message: "Email API timed out", api_url: "http://api.emailoversight.com/api/EmailValidation?apitoken=00027b30-3981-4557-acd6-26c1d285524c&listid=" }
            //             }).then(function(response) {
            //                 console.log(response);
            //             }).catch(function(error) {
            //                 console.error("Error during API timeout logging:", error);
            //             });
            //         }

            //         $(".emailError").html(""), $("#emailAddressField").removeClass('invalid');
            //         if (typeof gtag === "function") {
            //             gtag('event', 'Validation', {
            //                 'event_category': 'Email Validated',
            //                 'event_label': 'Email'
            //             });
            //         }
            //         return "true";
            //     } else if ("failure" === t.data.status) {
            //         var r = "<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n<i class='fa fa-exclamation-triangle'></i>\n".concat(t.data.error_message, "\n</span>");
            //         $(".emailError").empty().html(r)
            //         return "false";
            //     }
            // }))
        } else {
            $(".emailError").html("<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n<i class='fa fa-exclamation-triangle'></i>\n Please check your Email address again.\n </span>");
            $("#emailAddressField").addClass('invalid');
            isValid = false;

        }
    }

    schoolSearch() {
        event.preventDefault();
        // tunnel.googleTracker($(this), flow);
        $("div.progress-meter").css({
            'visibility': 'hidden'
        });
        setTimeout(() => this.fieldValidator($(this)), 750);
    }

    getRedirectUrl() {
        // Send browser event data
        var browserEventData = {
            "category": "browser_event",
            "data": {
                "visitor_id": getCookie('mdTrackId'),
                "action": 2,
                "timestamp_of_event": getFormattedDate()
            }
        };
        sendEventData(browserEventData);

        localStorage.removeItem('redirectURL');
        let formValues = $("form").serialize();
        let subjects = [];
        $('.subjectCheckbox').each(function () {
            $(this).is(':checked') ? subjects.push($(this).val()) : "";
        });
        if (Array.isArray(subjects) && subjects.length) {
            formValues = formValues + "&subjects=" + subjects.join(", ");
        }

        var concentrations = [];
        $('.concentration_checkbox').each(function () {
            $(this).is(':checked') ? concentrations.push($(this).val()) : "";
        });
        if (Array.isArray(concentrations) && concentrations.length) {
            formValues = formValues + "&concentrations=" + concentrations.join(", ");
        }

        // console.log(formValues); return false;

        return $.ajax({
            type: "post",
            url: "assets/ajax/getRedirects.php",
            data: formValues,
            dataType: "json",
            accept: "json",
            success: function (urlValue) {
                if (urlValue.linkout_id === 13) {
                    localStorage.setItem("redirectURL", "clicklistings")
                    localStorage.setItem("tyOptions", JSON.stringify(urlValue.clicklistings))
                } else {
                    localStorage.setItem('redirectURL', urlValue.redirectUrl);
                }
                localStorage.setItem('linkout_id', urlValue.linkout_id);
            },
            error: function () {
                var redirectUrl = `www.collegeeducationinformation.com/application.php?publisher_id=72&sub_publisher_id=${localStorage.getItem('oid')}&sub_publisher_id2=${localStorage.getItem('reqid')}`;
                localStorage.setItem('redirectURL', redirectUrl);
                localStorage.setItem('linkout_id', urlValue.linkout_id);
            }
        })
    };

    getRetargetRedirect() {
        localStorage.removeItem('redirectURL');

        return $.ajax({
            type: "post",
            url: "assets/ajax/getRetargetRedirects.php",
            dataType: "json",
            accept: "json",
            success: function (urlValue) {
                if (typeof urlValue.redirectUrl === "object") {
                    localStorage.setItem("redirectURL", "clicklistings")
                    localStorage.setItem("tyOptions", JSON.stringify(urlValue.redirectUrl))
                } else {
                    localStorage.setItem('redirectURL', urlValue.redirectUrl);
                }
            }
        })
    }

    searchSchoolRetarget(parentClass) {
        let _this = this;
        $("html, body").animate({
            scrollTop: $('.ques-box').offset().top
        }, "fast");
        var formValues = $("form").serialize();
        return $.ajax({
            type: "post",
            url: "assets/ajax/retarget.php",
            data: formValues,
            dataType: "json",
            accept: "json",
            beforeSend: function () {
                // gtag('event','Step Completed',{'event_category':'Data Submitted','event_label':'Search Request'});

                $('#processModal').modal({
                    backdrop: 'static',
                    keyboard: false,
                    show: true
                });
                $(".modal-body.loading-results").html(parentClass._loadDomTemplate);
                $(".ldTemplate-wrapper .processing-text").html(_processingText1);
                //run this immediately you begin searching for schools
                setTimeout(parentClass.changeProcessingText, 4000, parentClass);
            },
            success: function (data) {
                _this.getRetargetRedirect();
            },
            error: function () {
                let url = new URL(location.href);
                url.searchParams.delete('retarget');
                location.assign(url);
            }
        })
    }

    schoolSearchRequest(parentClass) {
        //if the visitor is on degreespin and localStorage has ltid populate $("#s2").val(localStorage.ltid)
        let currentURL = window.location.hostname;
        if (currentURL == 'degreespin.com') {
            if (localStorage.hasOwnProperty("ltid")) {
                $("#s2").val(localStorage.ltid);
            }
        }

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        if (urlParams.get('ckmsc') && urlParams.get('ckmc') && !urlParams.get('reqid')) {
            $('#reqid').val(parentClass.getCookie('ckmsid'));
        }

        var formValues = $("form").serialize();
        let _this = this;

        var subjects = [];
        $('.subjectCheckbox').each(function () {
            $(this).is(':checked') ? subjects.push($(this).val()) : "";
        });
        if (Array.isArray(subjects) && subjects.length) {
            formValues = formValues + "&subjects=" + subjects.join(", ");
        }
        var concentrations = [];
        $('.concentration_checkbox').each(function () {
            $(this).is(':checked') ? concentrations.push($(this).val()) : "";
        });
        if (Array.isArray(concentrations) && concentrations.length) {
            formValues = formValues + "&concentrations=" + concentrations.join(", ");
        }
        $("html, body").animate({
            scrollTop: $('.ques-box').offset().top
        }, "fast");

        const affiliate_id = urlParams.get('affid')
        let reqid = "";
        if ($('#reqid').length) {
            reqid = $('#reqid').val();
        } else {
            reqid = urlParams.get('reqid');
        }
        localStorage.setItem('affid', affiliate_id);
        localStorage.setItem('reqid', reqid);
        const oid = urlParams.get('oid');
        localStorage.setItem('oid', oid);
        if (affiliate_id) {
            this.fireCustomAffiliateCompletionPixels(affiliate_id, reqid, urlParams.get('oid'));
            if (affiliate_id == '30929' || affiliate_id == '36308') {
                $("#fbc").val(parentClass.getCookie('_fbc'));
            }
        }
        var deferred = $.Deferred();
        _this.searchSchoolAjax(parentClass, formValues).done(function (data) {deferred.resolve(data);});
        return deferred.promise();
    }

    searchSchoolAjax(parentClass, formValues) {
        let _this = this;
        var deferred = $.Deferred();

        $.ajax({
            type: "post",
            url: "assets/ajax/school-search.php",
            data: formValues,
            dataType: "json",
            accept: "json",
            beforeSend: function () {
                if (typeof gtag === "function") {
                    gtag('event', 'Step Completed', {
                        'event_category': 'Data Submitted',
                        'event_label': 'Search Request'
                    });
                }

                //Tracking user submissions -> Whenever a user clicks on Submit after filling out the form
                // This keeps track of Total Prospects Counts

                // Send browser event data
                var browserEventData = {
                    "category": "browser_event",
                    "data": {
                        "visitor_id": getCookie('mdTrackId'),
                        "action": 3,
                        "timestamp_of_event": getFormattedDate()
                    }
                };
                sendEventData(browserEventData);

                $('#processModal').modal({
                    backdrop: 'static',
                    keyboard: false,
                    show: true
                });
                $(".modal-body.loading-results").html(parentClass._loadDomTemplate);
                $(".ldTemplate-wrapper .processing-text").html(_processingText1);
                //run this immediately you begin searching for schools
                setTimeout(parentClass.changeProcessingText, 4000, parentClass);
            },
            success: function (data) {
                console.log(data);

                //Get the lead_id from the data object and place it in a hidden field so that when
                //getRedirectUrl runs, it can pick up lead_id as part of the request
                const hasMatches = Array.isArray(data.matched_schools) && data.matched_schools.length > 0;

                // Pass true/false to the element with id `#matches`
                $('#matches').val(hasMatches);
                $('#lead_id').val(data.lead_id);
                _this.getRedirectUrl();
                deferred.resolve(data);

            },
            error: function (error) {
                // Reject the deferred if the second Ajax call fails
                deferred.reject(error);
            }
        })

        return deferred.promise();

    }

    fieldValidator(ele, url) {

        if ($("#phone1").val() !== "") {
            $('#phoneFormat1').val($("#phone1").val().replace(/\D/g, ''));
        }

        if ($("#city").val() == "" || $("#state").val() == "") {
            this.zipValidator($("#zip"));
        }

        if ($('#firstNameField').val() == "") {
            return false;
        }
        if ($('#lastNameField').val() == "") {
            return false;
        }
        if ($('#firstNameField').val().length < 2 || $('#firstNameField').val().length > 50) {
            return false;
        }
        if ($('#lastNameField').val().length < 2 || $('#lastNameField').val().length > 50) {
            return false;
        }
        if ($('#emailAddressField').val() == "") {
            return false;
        }
        if ($('#autocompleteAddress').val() == "") {
            return false;
        }
        if ($('#street').val() == "") {
            return false;
        }
        if ($('#zip').val() == "") {
            return false;
        }
        if ($('#city').val() == "") {
            return false;
        }
        if ($('#state').val() == "") {
            return false;
        }
        if ($('#phoneFormat1').val() == "") {
            return false;
        }
        if ($('.invalid').length) {
            return false;
        }

        if (!isValid) {
            return false;
        }

        var parentClass = this;
        parentClass._validatingText1 = "Validating your request";

        parentClass._processingText2 = "Checking <span style='color:#ff8300;'>" + $("select[name='subject']").find("option:selected").text() + "</span> Colleges in your area.";
        parentClass._processingText3 = "Compiling your results";

        // if($("#zipCode").val() === ""){
        $.when(parentClass.schoolSearchRequest(parentClass)).then(function (data) {
            parentClass.processLastField();
            parentClass._schoolResults = data;
            parentClass.displayCollegeResults(parentClass);
        }, function (data) {
            $('#processModal').modal('hide');
            var errors = data.responseJSON;
            $(".get, .getPhone").css("color", "#ff0000");
            $(".getFirstName, .getLastName, .getEmail, .getStreetAddress, .getTCPA_agreement").css("color", "#ff0000");
            $("ul.checkLabel .fa-square-o").css("color", "#ff0000");
            $(".getFirstName").empty();
            $(".getLastName").empty();
            $(".getEmail").empty();
            $(".getStreetAddress").empty();
            $(".getTCPA_agreement").empty();
            $("ul.checkLabel .fa-square-o").removeAttr("color");
            if (typeof errors.first_name !== "undefined") {
                $(".getFirstName").html(errors.first_name[0]);
            }
            if (typeof errors.last_name !== "undefined") {
                $(".getLastName").html(errors.last_name[0]);
            }
            if (typeof errors.email !== "undefined") {
                $(".getEmail").html(errors.email[0]);
            }
            if (typeof errors.street_address !== "undefined") {
                $(".getStreetAddress").html(errors.street_address[0]);
            }
            if (typeof errors.tc_agreement !== "undefined") {
                $(".getTCPA_agreement").html(errors.tc_agreement[0]);
            }
        });
        // } else {
        //     location.assign("https://mydegree.com");
        // }

    }


    changeProcessingText(parent) {
        $(".ldTemplate-wrapper .processing-text").empty().html(parent._processingText2).fadeIn("fast");

        // comment when it is time to stop the click listings for advanced degrees
        // parent.checkForAdvancedDegrees();
        setTimeout(parent.changeProcessingText2, 4000, parent); //7000
    }

    changeProcessingText2(parent) {
        $(".ldTemplate-wrapper .processing-text").empty().html(parent._processingText3).fadeIn("fast");
    }


    //handler tor skipping leads

    skipLead() {
        var parent = this;
        this._current_lead_counter++;
        var school_leads = parent._schoolResults;
        if (parent._current_lead_counter < school_leads.matched_schools.length &&
            parent._current_matched_counter < parent._schoolResults.allowed_max_matches
        ) {
            if (school_leads.matched_schools[parent._current_lead_counter]) {
                if (school_leads.matched_schools[parent._current_lead_counter].hasOwnProperty('source')) {
                    let source = school_leads.matched_schools[parent._current_lead_counter]['source'];
                    if (source === "UMA ppc") {
                        let redirectURL = localStorage.getItem('redirectURL');
                        const queryString = window.location.search;
                        const urlParams = new URLSearchParams(queryString);
                        let affiliate_id = urlParams.get('affid');
                        let oid = urlParams.get('oid');
                        let reqid = "";
                        if ($('#reqid').length) {
                            reqid = $('#reqid').val();
                        } else {
                            reqid = urlParams.get('reqid');
                        }
                        setTimeout(function () {
                            if (!redirectURL) {
                                redirectURL = 'www.collegeeducationinformation.com/application.php?publisher_id=72&sub_publisher_id=' + oid + '&sub_publisher_id2=' + reqid
                            }
                            location.assign('umactc.php?affid=' + affiliate_id + '&reqid=' + reqid + '&backuplinkout=' + encodeURIComponent(redirectURL));
                        }, 500);
                        return;
                    }
                }
            }
            parent._html_context = {
                school_match: school_leads.matched_schools[parent._current_lead_counter],
                current_lead_number: parent._current_lead_counter,
                first_name: parent._schoolResults.first_name,
                mdkey: parent._schoolResults.mdkey,
                emailid: parent._schoolResults.emailid,
                display_skip: (parent._schoolResults.display_skip !== undefined) ?
                    "display_skip" : null
            };

            // Send browser event data
            var browserEventData = {
                "category": "browser_event",
                "data": {
                    "visitor_id": getCookie('mdTrackId'),
                    "action": 1,
                    "timestamp_of_event": getFormattedDate()
                }
            };
            sendEventData(browserEventData);

            // Send form event data for Matches Page
            var formEventData = {
                "category": "form_event", 
                "data": {
                    "visitor_id": getCookie('mdTrackId'),
                    "page": "8",
                    "label": "Matches Page",
                    "value": "User Found a Match",
                    "timestamp_of_event": getFormattedDate()
                 }
            };
            sendEventData(formEventData);


            $.get('school_match.html?' + Math.random(), function (data) {
                var template2 = handle.compile(data);
                $("#school_match").empty().html(template2(parent._html_context)).fadeIn();
            });
        } else {
            $('#processModal').modal('hide');
            $("html, body").animate({
                scrollTop: $('body').offset().top
            }, "fast");
            // this.populate_first_name();
            $('.ques-box').hide();
            $('#lastCallSpinnerthing').show();
            parent.checkForLastCall(parent);
        }

    }

    // submit lead
    submitLead(ele) {
        $("#school_match").find("#tcpa_area_box").hide();
        var parent = this;
        var _this = ele;
        var form_invalid_validation = "";
        var form_values = {};
        let currentURL = window.location.hostname;
        if (currentURL == 'degreespin.com') {
            if (localStorage.hasOwnProperty("ltid")) {
                ele.closest("form").append('<input type="hidden" name="s2" value="' + localStorage.ltid + '" />');
            }
            ele.closest("form").append('<input type="hidden" name="host_url" value="https://degreespin.com" />');
        }
        var form_response = ele.closest("form");
        var email = $('#emailAddressField').val();
        var phoneNumber = $('#phoneFormat1').val();
        var dateType = $(".card7 .date-lead").map(function () {
            return this.value;
        }).get().join('-');
        if (window.location.href.indexOf("?") == -1) {
            var queryString = "";
            var affiliate_id = 1;
        } else {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            var affiliate_id = urlParams.get('affid')
        }
        $("#dateLeadFormatted").val(dateType);
        $(".custom-error-message").hide();
        $(".custom-question").find(".error.small").hide();
        if (affiliate_id == '30929' || affiliate_id == '36308') {
            ele.closest("form").append('<input type="hidden" name="fbc" value="' + this.getCookie('_fbc') + '" />');
            ele.closest("form").append('<input type="hidden" name="conversion_count" value="' + this.conversionCount + '" />');
            ele.closest("form").append('<input type="hidden" name="email" value="' + email + '" />');
            ele.closest("form").append('<input type="hidden" name="phoneFormat1" value="' + phoneNumber + '" />');
        }



        $.ajax({
            type: "post",
            url: "assets/ajax/lead-submit.php",
            data: form_response.serialize(),
            dataType: "json",
            accept: "json",
            beforeSend: function () {
                _this.find("span").html('<strong> Submitting...</strong>');
            },
            success: function (data) {
                $("#school_match").find("#tcpa_area_box").show();
                // trigger google tag here if "success"
                if (data[1] === "success") {
                    
                    // Send form event data for Submission Page
                    var formEventData = {
                        "category": "form_event",
                        "data": {
                            "visitor_id": getCookie('mdTrackId'),
                            "page": "9a",
                            "label": "Submission Page",
                            "value": "Successful Submission",
                            "timestamp_of_event": getFormattedDate()
                        }
                    };
                    sendEventData(formEventData);


                    parent.fireCustomAffiliatePixels(affiliate_id, data, email, phoneNumber, false);
                    if (data[4] !== undefined || data[5] !== undefined || data[6] !== undefined) {
                        // ensure the iframe is fully loaded before skipping

                        let queryString = window.location.search;
                        let urlParams = new URLSearchParams(queryString);
                        let offerid = urlParams.get('oid')
                        if (offerid != 8702) {
                            $.when(parent.buildIframePixel(data[4], data[5], data[6], data[7])).then(function () {
                                if (data[2] === "continue_next") {
                                    parent._current_matched_counter++;
                                    parent.skipLead()
                                } else if (data[2] === "dont_continue_next") { //liberty exclusive
                                    parent._current_matched_counter = 10;
                                    parent.skipLead();
                                } else if (data[2] === "no_continue") {
                                    var errorName = data[1][0].error_name;
                                    $(".custom-error-message").show();
                                    $(".custom-question").find("input[name='" + errorName + "']").closest(".cs").find(".error.small").show();
                                    _this.prop('disabled', false);
                                    parent.skipLead();
                                } else {
                                    parent.skipLead();
                                }
                            });
                        } else {
                            if (data[2] === "continue_next") {
                                parent._current_matched_counter++;
                                parent.skipLead()
                            } else if (data[2] === "dont_continue_next") { //liberty exclusive
                                parent._current_matched_counter = 10;
                                parent.skipLead();
                            } else if (data[2] === "no_continue") {
                                var errorName = data[1][0].error_name;
                                $(".custom-error-message").show();
                                $(".custom-question").find("input[name='" + errorName + "']").closest(".cs").find(".error.small").show();
                                _this.prop('disabled', false);
                                parent.skipLead();
                            } else {
                                parent.skipLead();
                            }
                        }
                    } else {
                        if (data[2] === "continue_next") {
                            parent._current_matched_counter++;
                            parent.skipLead()
                        } else if (data[2] === "dont_continue_next") { //liberty exclusive
                            parent._current_matched_counter = 10;
                            parent.skipLead();
                        } else if (data[2] === "no_continue") {
                            var errorName = data[1][0].error_name;
                            $(".custom-error-message").show();
                            $(".custom-question").find("input[name='" + errorName + "']").closest(".cs").find(".error.small").show();
                            _this.prop('disabled', false);
                            parent.skipLead();
                        } else {
                            parent.skipLead();
                        }
                    }
                } else {
                    // Send form event data for Failed Submission
                    var formEventData = {
                        "category": "form_event",
                        "data": {
                            "visitor_id": getCookie('mdTrackId'),
                            "page": "9b",
                            "label": "Submission Page",
                            "value": "Failed Submission",
                            "timestamp_of_event": getFormattedDate()
                        }
                    };
                    sendEventData(formEventData);

                    parent.skipLead();
                }
            },
            error: function (data) {
                $("#school_match").find("#tcpa_area_box").show();
                _this.prop('disabled', false);
                parent.skipLead();
            }
        });
    }

    displayCollegeResults(parent) {
        var email = $('#emailAddressField').val();
        var phoneNumber = $('#phoneFormat1').val();
        if (parent._schoolResults.hasOwnProperty('directSubmitResults')) {
            $.each(parent._schoolResults.directSubmitResults, function (key, data) {
                const searchString = window.location.search;
                const urlParams = new URLSearchParams(searchString);
                let affiliate_id = urlParams.get('affid');
                let nocake = urlParams.get('nocake');
                if (data[1] === "success") { // Smart Match SUbmissions // Page 8 + 9a -> Total matches
                    // 9a -> Just Smart matches
                    
                    // Send form event data for Successful Submission
                    var formEventData = {
                        "category": "form_event",
                        "data": {
                            "visitor_id": getCookie('mdTrackId'),
                            "page": "9a",
                            "label": "Submission Page",
                            "value": "Successful Submission",
                            "timestamp_of_event": getFormattedDate()
                        }
                    };
                    sendEventData(formEventData);

                    parent.fireCustomAffiliatePixels(affiliate_id, data, email, phoneNumber, true);
                    if (nocake) {
                        parent.nocakeDirectSubmitConversion(data[7], data[3], data[5], data[8]);
                    }
                }
                else {
                    // Send form event data for Failed Submission
                    var formEventData = {
                        "category": "form_event",
                        "data": {
                            "visitor_id": getCookie('mdTrackId'),
                            "page": "9b",
                            "label": "Submission Page",
                            "value": "Failed Submission",
                            "timestamp_of_event": getFormattedDate()
                        }
                    };
                    sendEventData(formEventData);
                }
            });
        }


        if (parent._schoolResults.searchResults !== "no results found") {

            // Send browser event data
            var browserEventData = {
                "category": "browser_event",
                "data": { 
                    "visitor_id": getCookie('mdTrackId'),
                    "action": 1,
                    "timestamp_of_event": getFormattedDate()
                }
            };
            sendEventData(browserEventData);

            // Send form event data for Matches Page
            var formEventData = {
                "category": "form_event",
                "data": { 
                    "visitor_id": getCookie('mdTrackId'),
                    "page": "8",
                    "label": "Matches Page",
                    "value": "User Found a Match",
                    "timestamp_of_event": getFormattedDate()
                }
            };
            sendEventData(formEventData);

            var school_leads = parent._schoolResults;
            parent._lead_count = school_leads.lead_count;
            if (school_leads.matched_schools[parent._current_lead_counter]) {
                if (school_leads.matched_schools[parent._current_lead_counter].hasOwnProperty('source')) {
                    let source = school_leads.matched_schools[parent._current_lead_counter]['source'];
                    if (source === "UMA ppc") {
                        let redirectURL = localStorage.getItem('redirectURL');
                        const queryString = window.location.search;
                        const urlParams = new URLSearchParams(queryString);
                        let affiliate_id = urlParams.get('affid');
                        let oid = urlParams.get('oid');
                        let reqid = "";
                        if ($('#reqid').length) {
                            reqid = $('#reqid').val();
                        } else {
                            reqid = urlParams.get('reqid');
                        }
                        setTimeout(function () {
                            if (!redirectURL) {
                                redirectURL = 'www.collegeeducationinformation.com/application.php?publisher_id=72&sub_publisher_id=' + oid + '&sub_publisher_id2=' + reqid;
                            }
                            location.assign('umactc.php?affid=' + affiliate_id + '&reqid=' + reqid + '&backuplinkout=' + encodeURIComponent(redirectURL));
                        }, 500);
                        return;
                    }
                }
            }

            parent._current_lead_counter < parent._lead_count && (
                parent._html_context = {
                    school_match: school_leads.matched_schools[parent._current_lead_counter],
                    current_lead_number: parent._current_lead_counter,
                    first_name: parent._schoolResults.first_name,
                    mdkey: parent._schoolResults.mdkey,
                    emailid: parent._schoolResults.emailid,
                    display_skip: (parent._schoolResults.display_skip !== undefined) ?
                        "display_skip" : null
                }, $.get('school_match.html?' + Math.random(), (function (data) {
                    var template2 = handle.compile(data);
                    $("#school_match").empty().html(template2(parent._html_context)).slideDown()
                })))
            // trigger on click of button parent._current_lead_counter++;
        } else {
            $('#processModal').modal('hide');
            // parent.populate_first_name();
            $("html, body").animate({
                scrollTop: $('body').offset().top
            }, "fast");
            $('.ques-box').hide();
            $('#lastCallSpinnerthing').show();
            parent.checkForLastCall(parent);
        }
    }


    checkForLastCall(parent) {

        if (localStorage.getItem("redirectURL") != null) {
            parent.cpcLastCallImplementation();
        } else {
            setTimeout(() => parent.checkForLastCall(parent), 500);
        }
    }
    processLastField() {
        $(".card-box.card8").hide(200);
        $(".card-box.card9").show(500);
        $('#processModal').modal('hide');
    }

    cpcLastCallImplementation() {
        localStorage.setItem('name', $("input[name='fname']").val());
        localStorage.setItem('qs', this._queryString);
        $('form').each(function () {
            this.reset()
        });
        location.assign("search.php");
    }

    appendCakeValues(t) {
        var e = -1 !== t.indexOf("affid=") ? t.substring(t.lastIndexOf("affid=") + 6) : "",
            r = -1 !== e.indexOf("&") ? e.substring(0, e.indexOf("&")) : e;
        $("#affid").val(r);
        var s = -1 !== t.indexOf("s1=") ? t.substring(t.lastIndexOf("s1=") + 3) : "",
            n = -1 !== s.indexOf("&") ? s.substring(0, s.indexOf("&")) : s;
        $("#s1").val(n);
        var i = -1 !== t.indexOf("s2=") ? t.substring(t.lastIndexOf("s2=") + 3) : "",
            a = -1 !== i.indexOf("&") ? i.substring(0, i.indexOf("&")) : i;
        $("#s2").val(a);
        var o = -1 !== t.indexOf("s3=") ? t.substring(t.lastIndexOf("s3=") + 3) : "",
            c = -1 !== o.indexOf("&") ? o.substring(0, o.indexOf("&")) : o;
        $("#s3").val(c)
    }

    buildIframePixel(offer_id, event_id, req_id, ap_value) {
        let dfd = $.Deferred();
        let ifrm = document.createElement('iframe');
        ifrm.setAttribute('id', 'ifrm');
        ifrm.setAttribute('width', '1');
        ifrm.setAttribute('frameborder', '0');
        ifrm.setAttribute('src', `https://revadstrk.com/p.ashx?o=${offer_id}&e=${event_id}&fb=1&t=TRANSACTION_ID&r=${req_id}&ap=${ap_value}`);

        let tag_point = document.getElementById('pixel_placeholder');
        tag_point.parentNode.insertBefore(ifrm, tag_point);
        dfd.resolve();
        return dfd.promise();
    }

    fireCustomAffiliatePixels(affiliate_id, data, email, phoneNumber, directSubmitFlag) {
        this.conversionCount++;
        if (directSubmitFlag) {
            if (typeof gtag === "function") {
                gtag('event', 'directsubmit_conversion' + this.conversionCount, {
                    'event_category': 'engagement',
                    'event_label': data[3],
                    'value': data[7],
                    'currency': 'USD'
                });
            }
        } else {
            if (typeof gtag === "function") {
                gtag('event', 'conversion' + this.conversionCount, {
                    'event_category': 'engagement',
                    'event_label': data[3],
                    'value': data[7],
                    'currency': 'USD'
                });
            }
        }
        if (affiliate_id == 34244) {
            var enhanced_conversion_data = {
                "email": email,
                "phone_number": phoneNumber
            };
            if (directSubmitFlag) {
                if (typeof gtag === "function") {
                    gtag('event', 'directsubmit_conversion' + this.conversionCount, {
                        'value': data[7],
                        'currency': 'USD',
                        'send_to': 'AW-697849736/qEEtCPaXzsMBEIiv4cwC'
                    });
                }
            } else {
                if (typeof gtag === "function") {
                    gtag('event', 'conversion' + this.conversionCount, {
                        'send_to': 'AW-697849736/qEEtCPaXzsMBEIiv4cwC',
                        'value': data[7],
                        'currency': 'USD'
                    });
                }
            }
        }
        if (affiliate_id == 35225) {
            if (typeof fbq === "function") {
                fbq('init', '678358923152872');
                fbq('track', 'Lead');
                fbq('track', 'Purchase' + this.conversionCount, {
                    value: data[7],
                    currency: 'USD'
                });
            }
        }
        if (affiliate_id == 29784) {
            if (typeof fbq === "function") {
                fbq('init', '693972227904386');
                fbq('track', 'Lead');
                fbq('track', 'Purchase', {
                    value: .6 * data[7],
                    currency: 'USD'
                });
            }
        }
        if (affiliate_id == 30929 || affiliate_id == 36308) {
            if (typeof fbq === "function") {
                fbq('init', '1455852961548446');
                fbq('track', 'Lead');
                fbq('track', 'Purchase' + this.conversionCount, { value: data[7], currency: 'USD', event_id: data[6]});
            }
            if (typeof gtag === "function") {
                gtag('event', 'conversion', {
                    'send_to': 'AW-11536600683/tH9ECIOa96AaEOuciv0q',
                    'value': data[7],
                    'currency': 'USD',
                    'transaction_id': data[6]
                });
            }
        }
        if (affiliate_id == 35012) {
            if (typeof fbq === "function") {
                fbq('init', '1264605674277500');
                fbq('track', 'Lead');
            }
        }

        if (affiliate_id == 31003) {
            $('<iframe src="https://www.onedegree.club/thankyou/" height="1" width="1"></iframe>').appendTo('body');
        }
        if (affiliate_id == 24504) {
            $('<iframe src="https://www.mydegreefinder.com/thankyou/" height="1" width="1"></iframe>').appendTo('body');
        }
        if (affiliate_id == 30672) {
            $('<!-- Snap Pixel Code --> <script type=\'text/javascript\'>' +
                '(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function(){a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};' +
                'a.queue=[];var s=\'script\';r=t.createElement(s);r.async=!0;r.src=n;var u=t.getElementsByTagName(s)[0];u.parentNode.insertBefore(r,u);})(window,document,' +
                '\'https://sc-static.net/scevent.min.js\');' +
                'snaptr("init", "acacb3d0-4fc5-4638-b740-1d6ccd3eb71e", {"user_email": $("#emailAddressField").val()});snaptr(\'track\', \'SIGN_UP\');</script>' +
                '<!-- End Snap Pixel Code -->').appendTo('body');
        }
        if (affiliate_id == 32976) {
            $('<script type="text/javascript">!function (w, d, t) {' +
                'w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};' +
                'ttq.load("C5KUEP51T98720DVUHLG");' +
                'ttq.page();' +
                '}(window, document, "ttq")</script>').appendTo('body');
        }
        if (affiliate_id == 30873) {
            const searchString = window.location.search;
            const urlParams = new URLSearchParams(searchString);
            let cid = urlParams.get('cid');
            if (cid == '51640') {
                $('<script>\n' +
                    'const queryString = window.location.search;\n' +
                    'const urlParams = new URLSearchParams(queryString);\n' +
                    ' var pixel_code = \'C50DOH2LQH64DC0FDOQ0\';\n' +
                    ' var event = \'Purchase\';\n' +
                    ' var img_s2s = document.createElement("img");\n' +
                    ' img_s2s.src = "https://tiktok.stackedmedia.com/api/event?ttclid=" + urlParams.get(\'ttclid\') + "&pixel_code=" + pixel_code + "&event=" + event;\n' +
                    '</script>').appendTo('body');
            } else if (cid == '52105') {
                // <!-- Meta Pixel Code -->// new pixel per eric 7/19 - Matt
                $("<script>\n" +
                    "!function(f,b,e,v,n,t,s)\n" +
                    "{if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n" +
                    "n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n" +
                    "if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n" +
                    "n.queue=[];t=b.createElement(e);t.async=!0;\n" +
                    "t.src=v;s=b.getElementsByTagName(e)[0];\n" +
                    "s.parentNode.insertBefore(t,s)}(window, document,'script',\n" +
                    "'https://connect.facebook.net/en_US/fbevents.js');\n" +
                    "fbq('init', '595716408605555');\n" +
                    "fbq('track', 'PageView');\n" +
                    "</script>\n" +
                    "<noscript><img height=\"1\" width=\"1\" style=\"display:none;\"src=\"https://www.facebook.com/tr?id=595716408605555&ev=PageView&noscript=1\"/></noscript>").appendTo('body');
                // <!-- End Meta Pixel Code -->
            }
        }
        if (affiliate_id == 13069) {
            if (typeof gtag === "function") {
                gtag('event', 'conversion' + this.conversionCount, {
                    'send_to': 'AW-811114386/2oQsCP-94aEDEJK_4oID',
                    'value': data[7],
                    'currency': 'USD'
                });
            }
        }
        if (affiliate_id == 34897) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const lptype = urlParams.get('lptype')
            switch (lptype) {
                case 'art':
                    fbq('init', '711093660328008');
                    fbq('track', 'Purchase', {
                        value: data[7],
                        currency: 'USD'
                    });
                    break;
                case 'nursing':
                    fbq('init', '501690938255314');
                    fbq('track', 'Purchase', {
                        value: data[7],
                        currency: 'USD'
                    });
                    break;
                case 'cybersecurity':
                    fbq('init', '303389865234847');
                    fbq('track', 'Purchase', {
                        value: data[7],
                        currency: 'USD'
                    });
                    break;
                case 'it':
                    fbq('init', '514759256823801');
                    fbq('track', 'Purchase', {
                        value: data[7],
                        currency: 'USD'
                    });
                    break;
                case 'digital':
                    fbq('init', '1070487983679676');
                    fbq('track', 'Purchase', {
                        value: data[7],
                        currency: 'USD'
                    });
                    break;
            }
        }

        if (affiliate_id == 35327 && this.conversionCount == 1) {
            if (typeof fbq === "function") {
                fbq('init', '545508377089659');
                fbq('track', 'Conversion', {
                    value: data[7],
                    currency: 'USD'
                });
            }
        }
    }

    fireCustomAffiliateCompletionPixels(affiliate_id, reqid, offerid) {
        if (affiliate_id == 36308 || affiliate_id == 36412) {
            try {
                // Create simple tracking events
                ttq.track('CompleteRegistration');
                ttq.track('CompletePayment', { 
                    value: 1, 
                    currency: 'USD' 
                });
                
                console.log('TikTok events fired successfully');
            } catch(e) {
                console.error('Error firing TikTok events:', e);
            }
            
            if (typeof gtag === "function") {
                gtag('event', 'conversion', {
                    'send_to': 'AW-11536600683/YmvLCLec7P8ZEOuciv0q',
                    'value': 1.0,
                    'currency': 'USD'
                });
            }
        }

        if (affiliate_id == 35225) {
            
            if (typeof fbq === "function") {
                fbq('init', '678358923152872');
                fbq('track', 'CompleteRegistration');
            }
            this.buildIframePixel(offerid, 1109, reqid, 0);
        }
        if (affiliate_id == 35327) {
            if (typeof fbq === "function") {
                fbq('init', '545508377089659');
                fbq('track', 'CompleteRegistration');
            }
        }

        if (affiliate_id == 30929 || affiliate_id == 36308) {
            if (typeof fbq === "function") {
                fbq('init', '1455852961548446');
                fbq('track', 'CompleteRegistration',{event_id: reqid});
            }
        }
    }

    nocakeDirectSubmitConversion(payout, school_name, event_id, aggregator_id) {
        $.ajax({
            type: "post",
            url: "assets/ajax/noCakeDirectSubmitConversion.php",
            data: {
                payout: payout,
                school_name: school_name,
                event_id: event_id,
                aggregator_id: aggregator_id
            },
            dataType: "json",
            accept: "json",
            success: function (data) {
                console.log('nocake direct submit conversion');
            }
        });
    }

    getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}

main = new Main();